export enum BuildProgrammePermissionEnum {
    None = 0x00,
    CanSearch = 0x01 << 0,
    CanView = 0x01 << 1,
    CanCreate = 0x01 << 2,
    CanEdit = 0x01 << 3,
    CanViewAll = 0x01 << 4
}
